import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';

@Component({
    selector: 'kiene-button',
    templateUrl: './kiene-button.component.html',
    styleUrls: ['./kiene-button.component.scss'],
})
export class KieneButtonComponent implements OnInit {
    @Input('buttonText') buttonText = 'button-text';
    @Input('permissionId') permissionId = 0;
    @Output() buttonClicked = new EventEmitter<boolean>();

    buttonVisible: boolean = false;

    constructor(private localStorageService: LocalStorageService) {}

    ngOnInit() {
        if (this.localStorageService.currentUserHasPermission(this.permissionId)) {
            this.buttonVisible = true;
        } else {
            this.buttonVisible = false;
        }
    }

    execute() {
        this.buttonClicked.emit(true);
    }
}
